import { Typography, List, ListItem, useTheme } from "@mui/material";
import { fleetInquiryDetailsStyles, getListItemStyles } from "./styles";

interface IProps {
  details: string[];
  description: string;
}

const FleetInquiryContent: React.FC<IProps> = ({ details, description }) => {
  const theme = useTheme();

  return (
    <>
      <List disablePadding sx={fleetInquiryDetailsStyles}>
        {details.map((value, index) => (
          <ListItem key={index} disablePadding sx={getListItemStyles(theme)}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              fontSize={{ xs: "1rem", md: "1.25rem" }}
            >
              {value}
            </Typography>
          </ListItem>
        ))}
      </List>

      <Typography variant="body1" color="text.secondary" fontSize={{ sm: 16 }}>
        {description}
      </Typography>
    </>
  );
};

export default FleetInquiryContent;
